import React from 'react';
import ElementHtmlComponent from '../text/html';
import ElementImageComponent from '../image/image';
import ElementStaticTextComponent from '../text/staticText';
import ElementStaticListComponent from '../list/staticList';
import {IElementImage} from '../../../incase-domain/elements/image';
import {IElementStaticText} from '../../../incase-domain/elements/staticText';
import {IElementHtml} from '../../../incase-domain/elements/html';
import {IElementStaticList} from '../../../incase-domain/elements/staticList';
import {ELEMENT} from '../../../incase-domain/elements/base/ElementTypes';
import {FLIP_CARD_SIDE, FlipCardElementTypes, IElementFlipCard} from '../../../incase-domain/elements/flipCard';
import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';

interface FlipCardElementProps {
    element: IElementFlipCard;
    flipCardSide: FLIP_CARD_SIDE;
    type: FlipCardElementTypes;
    device: DeviceType;
}

export default function FlipCardElement(props: FlipCardElementProps): JSX.Element {
    const {element, flipCardSide, type, device = DeviceType.DESKTOP} = props;

    switch (type) {
        case ELEMENT.IMAGE:
            return <ElementImageComponent element={element.flipCardElement[flipCardSide] as IElementImage} />;
        case ELEMENT.STATIC_TEXT:
            return <ElementStaticTextComponent element={element.flipCardElement[flipCardSide] as IElementStaticText} device={device} />;
        case ELEMENT.HTML:
            return <ElementHtmlComponent element={element.flipCardElement[flipCardSide] as IElementHtml} />;
        case ELEMENT.STATIC_LIST:
            return <ElementStaticListComponent element={element.flipCardElement[flipCardSide] as IElementStaticList} device={device} />;
        default:
            return <div />;
    }
}
